function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L1.70710678,0.292893219 L7,5.585 L12.2928932,0.292893219 C12.6533772,-0.0675907428 13.2206082,-0.0953202783 13.6128994,0.209704612 L13.7071068,0.292893219 C14.0976311,0.683417511 14.0976311,1.31658249 13.7071068,1.70710678 L13.7071068,1.70710678 L8.415,7 L13.7071068,12.2928932 C14.0675907,12.6533772 14.0953203,13.2206082 13.7902954,13.6128994 L13.7071068,13.7071068 C13.3165825,14.0976311 12.6834175,14.0976311 12.2928932,13.7071068 L12.2928932,13.7071068 L7,8.415 L1.70710678,13.7071068 C1.34662282,14.0675907 0.779391764,14.0953203 0.387100557,13.7902954 L0.292893219,13.7071068 C-0.0976310729,13.3165825 -0.0976310729,12.6834175 0.292893219,12.2928932 L0.292893219,12.2928932 L5.585,7 L0.292893219,1.70710678 C-0.0675907428,1.34662282 -0.0953202783,0.779391764 0.209704612,0.387100557 Z",
  id: "close-icon-path"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layouts",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Search---open",
  transform: "translate(-1335.000000, -43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-/-Icons-/-Close-/-blk",
  transform: "translate(1335.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-20"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#close-icon-path"
})), /*#__PURE__*/React.createElement("use", {
  id: "Combined-Shape",
  xlinkHref: "#close-icon-path"
}))));

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.f96d4b05.svg";
export { ForwardRef as ReactComponent };